import { Pipe, PipeTransform } from "@angular/core";
import { BeaconRegionDTO } from "../beacon-regions/BeaconRegion";

@Pipe({ name: 'beaconRegionFilter' })
export class BeaconRegionFilterPipe implements PipeTransform {
  /**
   * Transform
   *
   * @param {any[]} items
   * @param {string} searchText
   * @returns {any[]}
   */
  transform(items: BeaconRegionDTO[], searchText: string): any[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLocaleLowerCase();

    return items.filter(it => {
      return it.name.toLocaleLowerCase().includes(searchText);
    });
  }
}